import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PASEditDetails from "./pasSection/pasEditDetails";
import ConfirmDialog from "../../Dialog/ConfirmDialog";
// Custom Style

import { updatePasDetails } from "../../../dataSource/pas";
import { pasDetailFormStyle } from "../../../styles/jss/components/PAS/pasDetailFormStyle";
const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));
const PASEditForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const {
    pasDetails,
    setPasDetails,
    saleEditorValue,
    setSaleEditorValue,
    progressEditorValue,
    setProgressEditorValue,
    setEditable,
    buildAlert,
  } = props;

  const returnToDetails = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Return",
      dialogContent:
        "Are you sure to return to PAS Highlights for Project Team Attention?",
      confirmAction: () => returnToDetailsConfirmAction(),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const returnToDetailsConfirmAction = () => {
    window.location.href = "/pas";
  };

  const submitDetails = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Submit Details",
      dialogContent: "Are you sure to submit PAS Highlights Details?",
      confirmAction: () => submitDetailsConfirmAction(),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const submitDetailsConfirmAction = () => {
    updatePasDetails(pasDetails, pasDetails.details.pas_seq).then((res) => {
      setEditable(false);
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The PAS Highlighs change has been saved",
      });
    });
  };
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });
    setConfirmDialogOpen(true);
  };
  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  return (
    <Fragment>
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      {/* <Typography variant={"h6"} className={classes.pasEditHeader}>
        Edit PAS HighLight
      </Typography> */}
      <Grid container spacing={1}>
        <PASEditDetails
          pasDetails={pasDetails}
          setPasDetails={setPasDetails}
          saleEditorValue={saleEditorValue}
          setSaleEditorValue={setSaleEditorValue}
          progressEditorValue={progressEditorValue}
          setProgressEditorValue={setProgressEditorValue}
        />
        <br />
        <Grid item xs={12}>
          <Button onClick={submitDetails} variant="contained" color="primary">
            Save
          </Button>
          &nbsp;
          <Button onClick={returnToDetails} variant="contained" color="primary">
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default PASEditForm;
